import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../gd-components/base-component/base-component";

import Classes from 'classnames';

class CustomSelectorItem extends BaseComponent {

    static propTypes = {
        item: PropTypes.object.isRequired,
        onItemSelected: PropTypes.func,
        renderFunc: PropTypes.func,
    };

    state = {
        isFocused: false
    };

    constructor(props) {
        super(props);

        this._bind('onClick', 'onMouseOver', 'onMouseOut');
    }

    onClick() {
        this.props.onItemSelected(this.props.item);
    }

    onMouseOver(){
        this.setState({isFocused:true});
    }

    onMouseOut() {
        this.setState({isFocused:false});
    }

    render() {
        const { item} = this.props;

        if (item.type === 'header') {
            return (
                <div className="menu-header ui5-txt-tiny-header">{item.label}</div>
            )
        }


        const itemClass = Classes({
            "is-focused": this.state.isFocused,
            'multiselect': this.props.multiselect
        });

        if (this.props.renderFunc) {
            return <div className={Classes(this.props.className, itemClass)} onClick={this.onClick} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
                {this.props.renderFunc(this.props.item)}
            </div>;
        }

        let labelOut = item.label;
        if (this.props.renderFunc){
            labelOut = this.props.renderFunc(item);
        }

        const icon = item.icon ? <span className={Classes('icon', item.icon)}/> : false;

        let checkbox = false;
        if (this.props.multiselect) {
            const checkboxClasses = Classes('gd-cb','normal-14','i5-checkbox-ok','filled-type',{
                'selected': this.props.isSelected
            });
            checkbox = <div className={checkboxClasses} />;
        }

        return <div className={Classes(this.props.className, itemClass)} onClick={this.onClick} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
            {checkbox}
            {icon}
            {labelOut}
        </div>;
    }
}

module.exports = CustomSelectorItem;
